// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__USvHd","label":"Labeled_label__3X1bv","divider":"Labeled_divider__iDzIE"};